export default (eventType: string) => {
    const authEvents = ['USER_AUTH_RESET_TOKEN', 'USER_AUTH_OTP'];
    const uxEvents = ['PAYEE_CREATED'];

    if (authEvents.includes(eventType)) {
        return 'AUTH API';
    } else if (uxEvents.includes(eventType)) {
        return 'UX API';
    }
    return 'FI API';
}